import { Link } from "react-router-dom";
import { FileSearch } from "lucide-react";
import { ROUTES } from "@/config/routes";
import type { ExportJobDetail } from "@/types/api";

export function ExportDetailCell({ job }: { job: ExportJobDetail }) {
  return (
    <Link
      to={ROUTES.exportDetail(job.job_id)}
      className="btn-action-sm secondary inline-flex items-center gap-1"
    >
      <FileSearch size={13} />
      Details
    </Link>
  );
}
